import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Avatar,
  Container,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BOOKINGS } from '../../component/common/Routes/AppRoutes';
import { VENDOR_BOOKINGS } from '../../component/common/Routes/VendorRoutes';
import { CUSTOMER_BOOKINGS } from '../../component/common/Routes/CustomerRoutes';
import { resetBookingDetails } from '../../redux/Bookings/BookingAction';

const InstantBookingSuccessPage = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetBookingDetails());
  }, []);
  const getBookingsRoute = () => {
    switch (user?.role) {
      case 'Admin':
        return BOOKINGS;
      case 'Staff':
        return BOOKINGS;
      case 'Vendor':
        return VENDOR_BOOKINGS;
      case 'Customer':
        return CUSTOMER_BOOKINGS;
      default:
        return BOOKINGS;
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        py: 4,
      }}
    >
      <Container maxWidth='sm'>
        <Paper
          elevation={2}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            borderRadius: 1,
          }}
        >
          {/* Success Icon */}
          <Avatar className='success-icon'>
            <CheckCircleIcon sx={{ fontSize: 50 }} />
          </Avatar>

          <Typography variant='h5' component='h1' gutterBottom fontWeight={500}>
            Instant Booking Completed!
          </Typography>

          <Typography
            variant='body1'
            color='text.secondary'
            sx={{ mb: 4, maxWidth: '80%' }}
          >
            Your instant booking was successfully completed. Please check your
            registered email for confirmation details.
          </Typography>

          <Box
            sx={{
              display: 'flex',
              gap: 2,
              mt: 2,
              flexDirection: { xs: 'column', sm: 'row' },
            }}
          >
            <Button
              variant='contained'
              color='primary'
              onClick={() => {
                dispatch(resetBookingDetails());
                navigate(getBookingsRoute());
              }}
              sx={{ minWidth: 120 }}
            >
              View Booking
            </Button>
            <Button
              variant='outlined'
              color='primary'
              onClick={() => {
                dispatch(resetBookingDetails());
                navigate('/');
              }}
              sx={{ minWidth: 120 }}
            >
              Return Home
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default InstantBookingSuccessPage;